"use client";

import Link from "next/link";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export default function DealsError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <section className="w-full max-w-xl rounded-lg border border-border bg-card p-8 shadow-soft">
        <p className="text-[11px] font-black uppercase tracking-[0.22em] text-nv-red">Deals unavailable</p>
        <h1 className="mt-3 font-display text-4xl leading-none">We could not load local deals.</h1>
        <Alert variant="destructive" className="mt-5" role="alert">
          <AlertCircle />
          <AlertTitle>Deals feed failed</AlertTitle>
          <AlertDescription>
            The deals feed hit a database or network error. This is different from having zero published deals.
            {error.digest ? <p className="mt-2 text-xs">Reference: {error.digest}</p> : null}
          </AlertDescription>
        </Alert>
        <div className="mt-6 flex flex-wrap gap-3">
          <button type="button" onClick={reset} className="nv-button">Try again</button>
          <Link href="/" className="nv-button-secondary">Home</Link>
        </div>
      </section>
    </main>
  );
}
